import { render } from "./change-metrics.vue?vue&type=template&id=34d02a78&scoped=true"
import script from "./change-metrics.vue?vue&type=script&lang=js"
export * from "./change-metrics.vue?vue&type=script&lang=js"

import "./change-metrics.vue?vue&type=style&index=0&id=34d02a78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d02a78"]])

export default __exports__